module.exports = __webpack_public_path__ + "img/imgOrigin.95bc1ab4.gif";